import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { mergeStatusThresholds } from '@/lib/statusThresholds';

/**
 * Reads vehicle-status thresholds for the current org, merged over platform defaults.
 * Shape: { staleMinutes, idleSeconds, movingSpeedKmh }.
 * Stable across renders when the underlying settings don't change.
 */
export default function useStatusThresholds() {
  const override = useSelector((state) => state.org.settings?.statusThresholds);
  return useMemo(() => mergeStatusThresholds(override), [override]);
}
